import {Navigate, useLocation} from 'react-router'
import StorageHelper from '@freckle/educator-entities/ts/common/helpers/storage-helper'

const REDIRECT_KEY = 'teacherLoginRedirectDest'

const isInvalidRedirect = (dest: string) => dest.startsWith('/login') || dest.startsWith('/signup')

type RedirectSetProps = {
  to: string
}

export const RedirectSet = ({to}: RedirectSetProps) => {
  const location = useLocation()
  const params = location.search === '' ? '?redirect' : `${location.search}&redirect`
  const dest = `${location.pathname}${params}`

  if (!isInvalidRedirect(dest)) {
    StorageHelper.setSecureCookie(REDIRECT_KEY, encodeURIComponent(dest))
  }
  return <Navigate to={to} replace />
}

export const RedirectConsume = ({defaultRoute}: {defaultRoute: () => string}) => {
  const nextUrl = StorageHelper.getCookie(REDIRECT_KEY)
  StorageHelper.clearSecureCookie(REDIRECT_KEY)
  if (nextUrl !== null && nextUrl !== undefined) {
    return <Navigate to={decodeURIComponent(nextUrl)} replace />
  } else {
    return <Navigate to={defaultRoute()} replace />
  }
}
